export default __webpack_public_path__ + "static/media/price-up.6c245321.svg";